<div class="flex items-center justify-center h-full">
  <div class="w-fit h-fit animate-spin fixed">
    <img src="assets/icons/loaderCircle.svg" alt="" />
  </div>
  <div class="w-fit h-fit">
    <img src="assets/icons/iconLoader.svg" alt="Cargando..." />
  </div>
</div>
